import React from "react";
import { StyledDiv } from "./Section10.style";
import Vector from "../../assets/images/Vector-10.png";
import styled from "styled-components";
const LeftImageContainer = styled.div`
  position: relative;
  
`;
const Section10 = () => {
  return (
    <StyledDiv>
      <LeftImageContainer>
        <img src={Vector} alt="image"  style={{position:'absolute',top: '70px',left: '0px',zIndex:'1'}}/>
      </LeftImageContainer>
      <div className="container py-5 text-center register-myindici">
        <div className="row mt-5 mb-3">
          <div className="col-md-12">
          <h2 className="myindici-heading2">How to Register with myindici</h2> 
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <p className="benefitsmyindici  mb-3">
              If your medical practice uses myindici, registering couldn't be
              easier. Simply contact your practice and let them know you want a
              myindici account, and they will do the rest!
            </p>
          </div>
        </div>
      </div>
    </StyledDiv>
  );
};

export default Section10;
